import { STOrientationDmlC } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import type {
    IBaseSubChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/base-sub-chart.interface';
import { CoordinateOption } from '@tencent/chart/lib/antv/g2/interface';

export class Coordinate {
    public constructor(protected subChartProperty: IBaseSubChartProperty) {}

    public getConfig(): CoordinateOption {
        const { xAxis, yAxis } = this.subChartProperty;
        const actions: any[] = [];
        if (yAxis?.scaling?.orientation === STOrientationDmlC.maxMin) {
            actions.push(['reflect', 'y']);
        }
        if (xAxis?.scaling?.orientation === STOrientationDmlC.maxMin) {
            actions.push(['reflect', 'x']);
        }

        return {
            actions,
        };
    }
}
